module.exports = __webpack_public_path__ + "img/liucheng2.7d683bde.png";